import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import useAuth from "src/hooks/useAuth";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import v2_actionListaTagsChats from "src/actions/v2/chats/v2_actionListaTagsChats";
import { RowInput } from "src/components/forms/RowInput";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import Label from "src/components/Label";
import { Switch } from "src/@/components/ui/switch";
import { Divider } from "@mui/material";
import Iconify from "src/components/Iconify";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";

const notas = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
]


const CardChatFeedback = ({
    actionPhase,
    actionState,
    changeActionState,
    users
}) => {
    const { cliente } = useAuth();
    const [tags, setTags] = useState([]);
    const [canais, setCanais] = useState([]);

    async function buscarListaTags() {
        try {
            const querys = `?cliente_id=${cliente._id}`;
            const response = await v2_actionListaTagsChats(querys);
            setTags(response.data.data);
        } catch (error) {
            console.error("Erro ao buscar lista de tags:", error);
        }
    }

    async function buscarListaCanais() {
        try {
            const response = await actionListaCanaisPorCliente(cliente._id);
            setCanais(response.data.data || []);
        } catch (error) {
            console.error("Erro ao buscar lista de canais:", error);
        }
    }

    let canaisFormatted = canais?.map((canal) => {
        return {
            value: canal.cliente_id || canal.clienteId,
            label: canal.nome
        }
    });

    useEffect(() => {
        buscarListaTags();
        buscarListaCanais();
    }, []);

    const listFormat = tags.map((tag) => ({
        value: tag._id,
        label: tag.nome,
    }));

    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="space-y-4 flex flex-col gap-2">
                    <RowInput
                        isRequired={true}
                        label="Canal"
                        info={"Canais que estão atrelados ao chat"}
                        input={
                            <MultiSelect
                                options={canaisFormatted}
                                onValueChange={(e) =>
                                    changeActionState({ name: "chatChannels", value: e })
                                }
                                defaultValue={actionState.chatChannels}
                                placeholder="Selecionar canais"
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <RowInput
                        label="Notas"
                        input={<MultiSelect
                            options={notas}
                            onValueChange={(e) => {
                                console.log(e);
                                let event = {
                                    name: "feedbacks",
                                    value: e
                                }
                                changeActionState(event);
                            }}
                            defaultValue={actionState?.feedbacks}
                            placeholder="Selecionar Notas"
                            variant="inverted"
                            animation={2}
                            maxCount={3}
                        />}
                    />

                    <div className="text-sm font-semibold bg-slate-100 p-2 rounded-md">
                        Filtros
                    </div>



                    <RowInput
                        label="Usuários"
                        input={<MultiSelect
                            options={users}
                            onValueChange={(e) => {
                                console.log(e);
                                let event = {
                                    name: "chatUsersAssign",
                                    value: e
                                }
                                changeActionState(event);
                            }}
                            defaultValue={actionState?.chatUsersAssign}
                            placeholder="Selecionar usuarios"
                            variant="inverted"
                            animation={2}
                            maxCount={3}
                        />}
                    />

                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />

                </div>
            </CardContent>
        </Card>
    );
};

export default CardChatFeedback;
